import {makeStyles} from "@fluentui/react-components";

export namespace Styles {
    export const useEditorStyles = makeStyles({
        field: {
            maxWidth: '480px'
        }
    })
}